import { Box } from "@mui/material";

const Section4 = () => {
	return (
		<Box className="div4" sx={{ height: "100vh", px: 10 }}>

		</Box>
	)
}

export default Section4;